// @flow

import styled, { css } from "styled-components";
import { fontBold, fontMedium, defaultSize } from "../../_static/Typography";

import buildColor from "../../_static/ColorPalette";

export default styled.div`
  display: flex;
  font-size: ${defaultSize};
  font-style: normal;
  ${({ nonNumeric, isWinner }) =>
    nonNumeric
      ? css`
          font-family: ${fontMedium};
          font-weight: 500;
          line-height: 19px;
          color: ${buildColor("grey", "700")};
        `
      : css`
          font-family: ${fontBold};
          font-weight: bold;
          line-height: 22px;
          color: ${isWinner
            ? buildColor("green", "600")
            : buildColor("grey", "800")};
        `}
`;
